import axios from "axios";
import { appConstants } from "./appConstants";
import { generateToken } from "./generic";
import { store } from "Store/store";
export async function recoveryRequest(path = "", body, method = "post") {
  try {
    const { data } = await axios({
      method,
      url: `${appConstants.baseURL}recovery${path}`,
      data: body,
      headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
      timeout: 90000,
    });
    if (!data.Result_Status)
      throw new Error(data.Result_Message || "Recovery request failed.");
    return data.Result_Output;
  } catch (error) {
    if (error.response?.data?.Result_Message === "TokenExpiredError") {
      try {
        const user = JSON.parse(
          sessionStorage.getItem("LOGIN_DETAILS") || "{}"
        );
        await generateToken(user._id, store.dispatch);
      } catch (_) {}
    }
    throw new Error(
      error.response?.data?.Result_Message ||
        error.message ||
        "Recovery request failed."
    );
  }
}
